var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-errors"},[_c('transition-group',{attrs:{"name":"slide"}},_vm._l((_vm.mainErrors),function(error){return _c('MainError',{key:error.id,attrs:{"error":error},on:{"remove":_vm.removeMainError}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }